import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-728a5be5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-page"
}
const _hoisted_2 = { class: "content-page-title" }

import { ref } from 'vue';
import { useRoute } from 'vue-router';

import TextBlock from '@/components/Content/TextBlock.vue';
import CookieCheckbox from '@/components/Cookie/CookieCheckbox.vue';
import NewsletterBlock from '@/components/Content/NewsletterBlock.vue';

import { ContentPage } from '@functions/model/content';
import { useMeta } from '@/store/useMeta';
import { contentfulService } from '@/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPage',
  async setup(__props) {

let __temp: any, __restore: any

const page = ref<ContentPage | null>(null);
const route = useRoute();

if (route.params.slug && typeof route.params.slug === 'string') {
  page.value = (
  ([__temp,__restore] = _withAsyncContext(() => contentfulService.getContentPageBySlug(route.params.slug))),
  __temp = await __temp,
  __restore(),
  __temp
);
}

useMeta({
  title: page.value?.title,
  description: page.value?.textWithImage?.[0]?.text,
  canonical: `/content/${page.value?.slug}`
});

return (_ctx: any,_cache: any) => {
  return (page.value)
    ? (_openBlock(), _createElementBlock("article", _hoisted_1, [
        _createElementVNode("header", null, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(page.value.title), 1)
        ]),
        (page.value.textWithImage)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(page.value.textWithImage, (textBlock, index) => {
              return (_openBlock(), _createBlock(TextBlock, {
                key: index,
                content: textBlock
              }, null, 8, ["content"]))
            }), 128))
          : _createCommentVNode("", true),
        (page.value.newsletterBlock)
          ? (_openBlock(), _createBlock(NewsletterBlock, {
              key: 1,
              class: "content-page-newsletter",
              block: page.value.newsletterBlock,
              "page-type": "content"
            }, null, 8, ["block"]))
          : _createCommentVNode("", true),
        (page.value.showCookieConsent)
          ? (_openBlock(), _createBlock(CookieCheckbox, { key: 2 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})